/* stylelint-disable */
import styled from 'styled-components';
import breakpoints from 'app/shared/components/LandingPageRefresh/breakpoints';
import Page from 'app/shared/containers/Page';

export const LandingPage = styled(Page)`
    margin-top: -1px;
`;


export const CtaPhoneInput = styled.div`
    width: 100%;

    @media ${breakpoints.medium} {
        margin: 0 auto;
        width: 382px;
    }
`;

export const CtaButtonWrapper = styled.div`
    display: block;
    margin: 0 auto;
    padding-top: 8px;
    width: 214px;

    @media ${breakpoints.medium} {
        display: inline-block;
        margin: 0;
        width: initial;
    }
`;

export const CtaInputWrapper = styled.div`
    display: block;
    margin: 0 auto;
    width: 214px;

    @media ${breakpoints.medium} {
        display: inline-block;
        margin: 0 13px 0 0;
    }
`;

export const CtaAppSubtext = styled.div`
    opacity: 0.8;
    color: #FFFFFF;
    font-family: "Open Sans";
    font-size: 12px;
    letter-spacing: 0;
    line-height: 16px;
    margin: 14px auto 0 auto;
    text-align: center;
    width: 100%;

    @media ${breakpoints.medium} {
        max-width: 540px;
    }
`;

export const Inline = styled.div`
    display: inline-block;
    margin: ${({ margin }) => (margin || '0')};
`;

export const CrossPromoTitle = styled.div`
    color: #3E3E4E;
    font-family: 'Open Sans', sans-serif;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24.7px;
    padding: 0 54px;
    text-align: center;
`;

export const PhoneInputError = styled.div`
    box-sizing: border-box;
    color: #FFFFFF;
    display: block;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    height: 16px;
    margin: 8px auto;
    text-align: center;

    @media ${breakpoints.medium} {
        text-align: left;
        width: 382px;
    }
`;

export const PaidListingMessage = styled.div`
    display: inline-block;
`;
